<template>
<div id="ProfileRecommendations" class="row">
    <div class="chart-segment-options align-items-start col-2">
        <modal-link modal-id="Show Recommendations" :content-list="pageContent"></modal-link>
        <a href="#!" v-show="!displayProfileRecommendations" @click="handleToggle">Show Recommendations<i class="fa fa-chevron-down ml-1"></i></a>
        <a href="#!" v-show="displayProfileRecommendations" @click="handleToggle">Hide Recommendations<i class="fa fa-chevron-up ml-1"></i></a>
    </div>
    <div v-show="displayProfileRecommendations && !isVerbatimLocked" class="product-recommendations-section col-10">
        <div>
            <div class="product-recommendations-intro text-primary">
                Generating Roadmap Recommendations uses data from your current Profile and Sentiment Themes above. Select which parts below to include for generating recommendations.
            </div>
            <div class="chart-criteria-section-1-product-recommendations-section pb-2">
                <div class="chart-criteria-row">
                    <div class="form-group">
                        <input id="includeValueGaps" name="includeValueGaps" type="checkbox" true-value="Y" false-value="N" v-model="includeValueGaps" />
                        <span class="ml-1 mr-3 mb-0">Include Value Gaps</span>
                    </div>
                    <div class="form-group">
                        <input id="includeExpectations" name="includeExpectations" type="checkbox" true-value="Y" false-value="N" v-model="includeExpectations" />
                        <span class="ml-1 mr-3 mb-0">Include Expectations</span>
                    </div>
                    <div class="form-group">
                        <input id="includePerformance" name="includePerformance" type="checkbox" true-value="Y" false-value="N" v-model="includePerformance" />
                        <span class="ml-1 mr-3 mb-0">Include Performance</span>
                    </div>
                    <div class="form-group">
                        <input id="includeWillingnessToPay" name="includeWillingnessToPay" :disabled="!enableWillingnessToPay" type="checkbox" true-value="Y" false-value="N" v-model="includeWillingnessToPay" />
                        <span class="ml-1 mb-0">Include Willingness %s</span>
                    </div>
                </div>
                <div class="chart-criteria-row">
                    <div class="form-group">
                        <input id="includeRelativeStrength" name="includeRelativeStrength" :disabled="!enableIncludeRelativeStrength" type="checkbox" true-value="Y" false-value="N" v-model="includeRelativeStrength" />
                        <span class="ml-1 mr-3 mb-0">Include Relative Strength</span>
                    </div>
                    <div class="form-group">
                        <input id="includeSentimentThemes" name="includeSentimentThemes" :disabled="(!sentimentsData || Object.keys(sentimentsData).length === 0)" type="checkbox" true-value="Y" false-value="N" v-model="includeSentimentThemes" />
                        <span class="ml-1 mr-3 mb-0">Include Sentiment Themes</span>
                    </div>
                </div>
                <div class="chart-criteria-row">
                    <div class="form-group pl-0 pr-3">
                        <div class="d-flex align-items-center flex-nowrap">
                            <label class="sub-heading-label pr-2 m-0 text-nowrap text-primary"># of Recommendations</label>
                            <div class="theme-select-width">
                                <select
                                id="number_of_recommendations"
                                name="number_of_recommendations"
                                class="custom-select shadow w-100"
                                v-model="number_of_recommendations"
                                >
                                    <option value="5">Select</option>
                                    <option v-for="(option, idxNumberOfRecommendationOptions) in number_of_recommendation_options" v-bind:value="option" v-bind:key="idxNumberOfRecommendationOptions">
                                        {{ option }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-group pl-0 pr-3">
                        <div class="d-flex align-items-center flex-nowrap">
                            <label class="sub-heading-label pr-2 m-0 text-nowrap text-primary">AI Toolset</label>
                            <div class="theme-select-width">
                                <select
                                id="recommendations_ai_type_id"
                                name="recommendations_ai_type_id"
                                class="custom-select shadow w-100"
                                v-model="recommendations_ai_type_id"
                                >
                                    <option v-for="(ai_type_option, idxAiTypeOptions) in ai_type_options" v-bind:value="ai_type_option.aiTypeId" v-bind:key="idxAiTypeOptions">
                                    {{ ai_type_option.displayName }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
            <button class="btn btn-primary generate-recommendations-btn" @click="generateProfileRecommendations" :disabled="(processInitiated && !processingComplete) || deactivateGeneratedThemesButton || oneTimeRunOnlyForInsiderUser || noInputSelected">
                <span>Generate Recommendations</span>
                <span v-show="processInitiated && !processingComplete" class="spinner-border spinner-border-sm"></span>
            </button>
            <div v-show="oneTimeRunOnlyForInsiderUser" class="form-row pt-1">
                <div v-show="oneTimeRunOnlyForInsiderUser" class="text-danger ml-2">Additional Recommendation Analysis is not active for your account. Contact your W Ratings Advisor or <a href="mailto:insider@wratings.com">insider@wratings.com</a> for more information.</div>
            </div>
            <div v-show="deactivateGeneratedThemesButton" class="form-row pt-1">
                <div v-show="deactivateGeneratedThemesButton" class="text-danger ml-2">Recommendation Analysis is not active for your account. Contact your W Ratings Advisor or <a href="mailto:insider@wratings.com">insider@wratings.com</a> for more information.</div>
            </div>
        </div> 
    </div>
    <!-- Response area -->
    <div class="row justify-content-center pt-4" v-show="showResults && displayProfileRecommendations">
        <div class="col-10">
            <span style='color:#7F7F7F; font-family: "Franklin Gothic Medium Cond";'>
                AI-generated actions are for advisory purposes and should be used as a starting point for your roadmap.
            </span>
        </div>
        <div id="product-recommendations-data-container"  class="col-10">
            <div class="chart-header-container d-flex">
                <div class="d-flex title" style="padding-left: 0 !important;">
                <h4 class="text-primary mt-1 mb-0">
                    {{ title }}
                </h4>
                </div>          
            </div>
            <div class="pt-2">
                <button type="button" class="btn btn-primary ml-auto" @click="$modal.show('print-instant-report-modal')">Save Report</button>
            </div>
            <table id="recommendations-detailed-data" class="recommendations-table" cellspacing="0" style="padding-left: 0 !important;">
                <thead class="align-middle">
                    <tr>
                        <th class="align-middle text-center" style="padding-right: 0px !important">#</th>
                        <th class="align-middle">Recommendation</th>
                        <th class="align-middle">The Data</th>
                        <th class="align-middle">The Action</th>
                        <th class="align-middle">The "Why" behind the Recommendation</th>
                    </tr>                    
                </thead>
                <tbody></tbody>
            </table>
        </div>
    </div>
</div>
</template>

<script>
import $ from "jquery";
import ContentMixins from "../../mixins/ContentMixins.vue";
import ViewMixins from "../../mixins/ViewMixins.vue";
import SurveyService from "../../services/survey.service";
import UserService from "../../services/user.service";
import AdminService from "../../services/admin.service";
import AdminMixins from "../../mixins/AdminMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import ChartCriteriaMixins from "../../mixins/ChartCriteriaMixins.vue";
import GoogleService from "../../services/google.service";
import ChartDisplaySkeleton from "../../components/skeleton/ChartDisplaySkeleton.vue";
import ClientSettingsService from "../../services/client.settings.service";
import AIService from "../../services/ai.service";
import TableService from "../../services/table.service";
import ReportService from "../../services/report.service";

export default {
    name: "ProductRecommendations",
    mixins: [ContentMixins, ViewMixins, DataTableMixins, AdminMixins, ChartCriteriaMixins, GoogleService],
    components: {
        // ChartDisplaySkeleton
    },
    data() {
        return {
            title: "Roadmap Recommendations",
            displayProfileRecommendations: false,
            clientSettings: {}, 
            includeValueGaps: "Y",
            includeExpectations: "Y",
            includePerformance: "Y",
            includeWillingnessToPay: "Y",
            savedCardWillingnessToPay: "Y",
            includeRelativeStrength: "N",
            includeSentimentThemes: "N",
            processingComplete: true,
            processInitiated: false,
            showResults: false,
            topRecommendations: [],
            autoProcessRecommendationsByAI: false,
            number_of_recommendation_options: [1,2,3,4,5,10,15],
            number_of_recommendations: 5,
            isSavedCard: false,
            deactivateGeneratedThemesButton: false,
            oneTimeRunOnlyForInsiderUser: false,
            recommendations_ai_type_id: 0,
            ai_type_options: [],
            AUTO_SWITCH_LLM_MESSAGE: "Due to high demand, selected AI Model could not process your request. Results are generated using an alternative model.",
            table: {
                id: "recommendations-detailed-data",
                class: "table display wrap row-border table-hover",
                configuration: {
                    dom: '<"w-100"<"d-flex"><B>>frtip',      
                    searching: false,
                    paging: false,
                    pageLength: 25,
                    select: true,
                    processing: false,
                    responsive: false,
                    destroy: true,
                    info: false,
                    order: [],
                    ordering: false,
                    keys: true,
                    sort: false,
                    bSortable: false,
                    bSort: false,
                    buttons: [],
                },
            },            
        };
    },
    props: {
        enableSentimentThemes: {
            type: Boolean,
            default: true
        },
        enableWillingnessToPay: {
            type: Boolean,
            default: true
        },
        enableIncludeRelativeStrength: {
            type: Boolean,
            default: true
        },
        entrySurveyCode: {
            type: String,
            default: SurveyService.getSurveyCode()
        },
        autoGenerateRecommendations: {
            type: Boolean,
            default: false
        },
        clientChart: {
            type: Object,
            default: function() {
                return {};
            }
        },
        clientObject: {
            type: Object,
            default: function() {
                return {};
            }
        },
        recommendationsData: {
            type: Object,
            default: () => null
        },
        sentimentsData: {
            type: Object,
            default: () => null
        },
        sentimentThemesGenerating: {
            type: Boolean,
            default: false
        },
        criteriaResultsCompanyList: {
            type: Array,
            default: function() {
                return [];
            }
        },
    },
    computed: {
        isVerbatimLocked() {
            return this.clientSettings.aiTypeId == 0;
        },
        noInputSelected() {
            if (this.includeValueGaps == "N" && this.includeExpectations == "N" 
                && this.includePerformance == "N" && this.includeWillingnessToPay == "N"
                && this.includeRelativeStrength == "N" && this.includeSentimentThemes == "N" ) {
                    return true;
                }
            return false;
        },
        noOfRespondents: function() {
            let returnNumber = 0;
            let resultClientList = this.criteriaResultsCompanyList.find(x => x.type === "client");
            if (typeof resultClientList !== "undefined") {
                if (resultClientList.list.length > 0) {
                    returnNumber = resultClientList.list[0].numberOfResults;
                }        
            }
            return returnNumber;
        },
    },
    async mounted() {
        await this.getClientSettings();
        this.loadAITypes();
    //    console.log('AI Recommendations chartData = ', this.aiRecommendations);
    },
    created() {},
    methods: {
        loadAITypes() {
            AIService.getAllActiveAITypes(this.setAITypeOptions);
        },
        setAITypeOptions(response) {
            this.ai_type_options = response;
        },
        getClientSettings() {
            return new Promise((resolve, reject) => {
                ClientSettingsService.getClientSettings(
                this.clientCode, 
                (response) => {
                    this.setClientSettings(response);
                    resolve(response); // Now the "await" in mounted will wait for this
                }, 
                this
                );
            });
        },
        async waitForDownloadCommentsToFinish() {
            const downloadComments = this.$parent?.$refs?.downloadComments;
            if (downloadComments == null) {
                return;
            }

            if (!downloadComments.processInitiated || downloadComments.processingComplete) {
                return;
            }
            this.displayProfileRecommendations = true;
            await new Promise(resolve => {
                const intervalId = window.setInterval(() => {
                    if (downloadComments.processingComplete) {
                        window.clearInterval(intervalId);
                        resolve();
                    }
                }, 200);
            });
        },
        initResultTables(all = []) {
            const posSel = "#recommendations-detailed-data";
            
            // destroy if exists
            this.destroyDt(posSel);

            this.table.columns = TableService.getTopRecommendationResultsTableAttributes();
            const baseCfg = $.extend(true, {}, this.table.configuration);
            const cols = this.table.columns;

            // Positive table configuration
            const cfgPos = $.extend(true, {}, baseCfg, {
                data: all,
                columns: cols,
                columnDefs: [
                    {
                        targets: 0,          // first column
                        createdCell: function (td) {
                            $(td).css('text-align', 'center');
                        }
                    }
                ]
            });
            // buttons: use different container ids if you want separate toolbar per table
            $.extend(cfgPos, TableService.getTableButtons(this, "product-recommendations-data-container", undefined, undefined, false, "Recommendations"));

            this.$nextTick(() => {
                this.dtPositive = $(posSel).DataTable(cfgPos);
                this.dtPositive.columns.adjust().draw();
            });
            this.isSavedComments = false;
        },

        destroyDt(selector) {
            if ($.fn.dataTable.isDataTable(selector)) {
                $(selector).DataTable().destroy();
            }
        },
        setEnableIncludeRelativeStrength: function() {
            if (this.enableIncludeRelativeStrength) {
                this.includeRelativeStrength = "Y";
            } else {
                this.includeRelativeStrength = "N";
            }
        },
        setEnableSentimentThemes:function() {
            if (this.enableSentimentThemes) {
                this.includeSentimentThemes = "Y";
            } else {
                this.includeSentimentThemes = "N";
            }
        },
        setEnableWillingnessToPay: function() {
            if (this.enableWillingnessToPay) {
                this.includeWillingnessToPay = "Y";
            } else {
                this.includeWillingnessToPay = "N";
            }
        },
        loadDefaultCriteria() {
            this.setEnableIncludeRelativeStrength();
            // this.setEnableSentimentThemes();
            this.setEnableWillingnessToPay();            
        },
        setClientSettings(response){
            this.clientSettings = ClientSettingsService.parseClientSettings(response.data.data);
            this.displayProfileRecommendations = (this.isVerbatimLocked || !this.processInitiated) ? false : true;
        },
        handleToggle() {
            if (this.isVerbatimLocked) {
                AdminService.displayErrorMessage({
                    text: "Profile Recommendations is not active for your organization. Contact your <br/>W Ratings Advisor for more information."
                });
                return;
            }
            this.toggleProfileRecommendations();
        },
        getDownloadFilename() {
            return "Recommendations - " + SurveyService.getSurveyName();
        },
        toggleProfileRecommendations() {
            let label = this.displayProfileRecommendations ? "close" : "open";
            GoogleService.logClickEvent("Profile Recommendations Section Toggle", label, 0, this);

            this.displayProfileRecommendations = !this.displayProfileRecommendations;
        },
        generateProfileRecommendations: async function(){
            if (this.recommendations_ai_type_id == "" || this.recommendations_ai_type_id == null || this.recommendations_ai_type_id == 0) {
                AdminService.displayErrorMessage({ text: "Please select AI Toolset to generate recommendations." });
                return;
            }
            this.processingComplete = false;
            this.processInitiated = true;
            this.showResults = false;
            this.topRecommendations = [];
            
            await this.$nextTick();
            try {
                if (this.includeSentimentThemes === "Y") {
                    await this.waitForDownloadCommentsToFinish();
                }

                this.$root.processServerRequest("Generating Recommendations");
                let params = new URLSearchParams();
                params.append("client_id", this.clientObject.clientId);
                params.append("survey_id", SurveyService.getSurveyId());
                params.append("user_id", UserService.getUserId());
                params.append("include_value_gaps", this.includeValueGaps);
                params.append("include_expectations", this.includeExpectations);
                params.append("include_performance", this.includePerformance);
                params.append("include_willingness_to_pay", this.includeWillingnessToPay);
                params.append("include_relative_strength", this.includeRelativeStrength);
                params.append("number_of_recommendations", this.number_of_recommendations);
                params.append("recommendations_ai_type_id", this.recommendations_ai_type_id);

                params.append("chart_data", JSON.stringify(this.buildRecommendationsData()));
                if(this.includeSentimentThemes == 'Y') {
                    const sentimentsData = this.sentimentsData;
                    if (sentimentsData && Array.isArray(sentimentsData.themes)) {
                        params.append("sentiment_themes", JSON.stringify(sentimentsData.themes));
                    } else {
                        this.includeSentimentThemes = "N"; // if no themes data, set to N to avoid errors in processing
                    }
                    if (sentimentsData && sentimentsData.startPeriod != null) {
                        params.append("download_commments_period", sentimentsData.startPeriod);
                    } else {
                        this.includeSentimentThemes = "N"; // if no themes data, set to N to avoid errors in processing
                    }
                    if (sentimentsData && sentimentsData.endPeriod != null) {
                        params.append("download_commments_end_period", sentimentsData.endPeriod);
                    } else {
                        this.includeSentimentThemes = "N"; // if no themes data, set to N to avoid errors in processing
                    }
                    if (sentimentsData && sentimentsData.numberOfThemes != null) {
                        params.append("number_of_themes", sentimentsData.numberOfThemes);
                    } else {
                        this.includeSentimentThemes = "N"; // if no themes data, set to N to avoid errors in processing
                    }
                    if (sentimentsData && sentimentsData.themesIncludePartialResponses != null) {
                        params.append("themes_include_partial_responses", sentimentsData.themesIncludePartialResponses);
                    } else {
                        this.includeSentimentThemes = "N"; // if no themes data, set to N to avoid errors in processing
                    }
                    if (sentimentsData && sentimentsData.themesIncludeExtraResponses != null) {
                        params.append("themes_include_extra_responses", sentimentsData.themesIncludeExtraResponses);
                    } else {
                        this.includeSentimentThemes = "N"; // if no themes data, set to N to avoid errors in processing
                    }
                    if (sentimentsData && sentimentsData.themesAiTypeId != null) {
                        params.append("themes_ai_type_id", sentimentsData.themesAiTypeId);
                    } else {
                        this.includeSentimentThemes = "N"; // if no themes data, set to N to avoid errors in processing
                    }
                }
                params.append("include_sentiment_themes", this.includeSentimentThemes);
                params.append("number_of_respondents", this.noOfRespondents);
                await AIService.processRecommendations(params, this.processRecommendationsCallbacks);
            } catch (error) {
                this.$root.processServerResponse();
                this.processingComplete = true;
                this.processInitiated = false;
            }
        },
        buildRecommendationsData() {
            const data = this.recommendationsData;
            
            const selectedCols = this.getSelectedColumnsForRecommendations(data);
            const colIndexes = this.getColumnIndexes(data, selectedCols);
            const filteredRows = this.getFilteredRows(data, colIndexes);

            return {
                cols: selectedCols, //headers
                rows: filteredRows,
                isPositiveCorrelation: data.isPositiveCorrelation
            };
        },
        getSelectedColumnsForRecommendations(data) {
            if (!data?.cols) return;
            const selectedCols = [];
            data.cols.forEach(col => {

                if (col.id === "need") {
                    selectedCols.push({ ...col });
                }
                if (this.includeValueGaps === "Y" && col.id === "gap") {
                    selectedCols.push({ ...col });
                }
                if (this.includeExpectations === "Y" && col.id === "customer-expectations") {
                    selectedCols.push({ ...col });
                }
                if (this.includePerformance === "Y" && col.id === "performance") {
                    selectedCols.push({ ...col });
                }
                if (this.includeWillingnessToPay === "Y" && col.id === "pricing-power") {
                    selectedCols.push({
                        ...col,
                        label: "Willing to expand"
                    });
                }
                if (this.includeRelativeStrength === "Y" && col.id === "relative-strength") {
                    selectedCols.push({ ...col });
                }
            });
            return selectedCols;
        },
        getColumnIndexes(data, selectedCols) {
            return selectedCols.map(sc =>
                data.cols.findIndex(c => c.id === sc.id)
            );
        },
        getFilteredRows(data, colIndexes) {
            const needLookup = {};
            (data.emotionalNeedNamesMap || []).forEach(n => {
                needLookup[n.needName] = n.dimensionName;
            });

            return data.rows.map(row => {
                return colIndexes.map(i => {
                    const cell = row.c[i];
                    let value = cell ? cell.v : '';
                    const colId = data.cols[i].id;
                    if (colId === "pricing-power" && value !== '') {
                        value = value + "%";
                    } else if (colId === "need" && value !== '') {
                        value = needLookup[value] || value; // replace if mapping exists
                    } else {
                        let numVal = parseFloat(value);
                        if (typeof numVal === 'number' && !isNaN(numVal)) {
                            value = numVal.toFixed(2); 
                        }
                    }
                    return value;
                });
            });
        },
        loadCriteriaData() {
            this.processingComplete = false;
            
            let params = new URLSearchParams(this.clientChart.criteria);
            let autoProcessRecommendationsByAI = params.get("auto_process_recommendations_by_ai") || false;
            if (autoProcessRecommendationsByAI == "true" || autoProcessRecommendationsByAI == true) {
                this.autoProcessRecommendationsByAI = true;
                this.includeValueGaps = params.get("include_value_gaps") || "Y";
                this.includeExpectations = params.get("include_expectations") || "Y";
                this.includePerformance = params.get("include_performance") || "Y";
                this.includeWillingnessToPay = params.get("include_willingness_to_pay") || "Y";
                this.savedCardWillingnessToPay = this.includeWillingnessToPay;
                this.includeRelativeStrength = params.get("include_relative_strength") || "Y";
                this.includeSentimentThemes = params.get("include_sentiment_themes") || "Y";
                this.number_of_recommendations = params.get("no_of_recommendations") || 5;
                this.recommendations_ai_type_id = params.get("recommendations_ai_type_id") || this.clientSettings.aiTypeId;
                
                this.showResults = true;
                this.displayProfileRecommendations = true;
                
                if (Object.keys(this.recommendationsData).length !== 0) {
                    this.generateProfileRecommendations();
                }
            }
            
        },
        saveToCard: function() {
            let params = new URLSearchParams();
            params.append("include_value_gaps", this.includeValueGaps);
            params.append("include_expectations", this.includeExpectations);
            params.append("include_performance", this.includePerformance);
            params.append("include_willingness_to_pay", this.includeWillingnessToPay);
            params.append("include_relative_strength", this.includeRelativeStrength);
            params.append("include_sentiment_themes", this.includeSentimentThemes);
            params.append("no_of_recommendations", this.number_of_recommendations);
            params.append("recommendations_ai_type_id", this.recommendations_ai_type_id);
            params.append("auto_process_recommendations_by_ai", true);

            // params.append("chart_data", JSON.stringify(this.buildRecommendationsData()));
            // if(this.includeSentimentThemes == 'Y') {
            //     params.append("sentiment_themes", JSON.stringify(this.sentimentsData));
            // }

            this.$emit("save-profile-recommendations-criteria", params);
        },
        processRecommendationsCallbacks(response) {
            this.deactivateGeneratedThemesButton = this.isInsiderUser && !this.isSavedCard ? true : false;
            this.oneTimeRunOnlyForInsiderUser = this.isInsiderUser && this.isSavedCard ? true : false;

            let statusCode = response.status;
            this.displayProfileRecommendations = true;
            if (statusCode == 200) {
                                
                const data = response.data.data || {};
                const response_ai_type_id = (data?.ai_type) ? (data?.ai_type.aiTypeId) : 0;
                if(response_ai_type_id != this.recommendations_ai_type_id) {
                    AdminService.displayInfoMessage({ text: this.AUTO_SWITCH_LLM_MESSAGE}, { duration: 8000 }); // can be appended with - data?.ai_type.displayName 
                }
                this.recommendations_ai_type_id = response_ai_type_id;

                this.saveToCard();
                if (typeof data.existingClientReport != "undefined" && data.existingClientReport != null) {
                    this.$emit("existing-client-report", data.existingClientReport);
                }
                this.topRecommendations = data.topRecommendations || [];
                this.showResults = true;
                this.initResultTables(this.topRecommendations );
            } else {
                AdminService.displayErrorMessage({ text: response.data.message });
                this.showResults = false;
                this.initResultTables([]);
            }
            this.$root.processServerResponse();
            this.processInitiated = false;
            this.processingComplete = true;
            this.autoProcessRecommendationsByAI = false;
        },
        resetValues() {
            this.destroyDt("#recommendations-detailed-data");
            this.showResults = false;
            this.topRecommendations = [];
            this.deactivateGeneratedThemesButton = this.isInsiderUser && !this.isSavedCard ? true : false;
            this.oneTimeRunOnlyForInsiderUser = this.isInsiderUser && this.isSavedCard ? true : false;
            this.processingComplete = true;
            this.processInitiated = false;
            this.autoProcessRecommendationsByAI = false;
            this.includeSentimentThemes = "N";
            this.includeRelativeStrength = "N";
            this.includeWillingnessToPay = "N";
            if (typeof this.clientSettings.aiTypeId != "undefined" && this.clientSettings.aiTypeId != null){            
                this.recommendations_ai_type_id = this.clientSettings.aiTypeId; 
            } else {
                this.recommendations_ai_type_id = 0; 
            }
        }, 
        getRecommendationsTableData() {
            const tableSelector = "#recommendations-detailed-data";
            if ($.fn.dataTable.isDataTable(tableSelector)) {
                const dataTable = $(tableSelector).DataTable();
                return TableService.getTableData(dataTable);
            }
            return [];
        },
        async saveDataForInstantReport(clientReportId) {
            await this.$nextTick();
            const clientId = this.clientObject.clientId;
            const tableData = this.getRecommendationsTableData();

            await Promise.all([
                ReportService.saveReportTableFileForInstantReport(tableData, "Table - Recommendations", clientId, clientReportId, this.saveReportTableFileCallback, this),
                ReportService.saveInstantReportPage(clientId, TableService.getReportTableContentByTable("recommendations-detailed-data"), "Table - Recommendations", clientReportId, this.title, this.saveReportPageCallback, this)
            ]);
        },
        saveReportTableFileCallback(response) {},
        saveReportPageCallback(response) {},
    },
    watch: {
        // enableSentimentThemes: function(newVal) {
        //     this.setEnableSentimentThemes();
        // },
        enableIncludeRelativeStrength: function(newVal) {
            if (!this.isSavedCard && !this.autoGenerateRecommendations) {
                this.includeRelativeStrength = newVal ? "Y" : "N";
            }
        },
        enableWillingnessToPay: function(newVal) {
            if (!this.isSavedCard && !this.autoGenerateRecommendations){
                this.includeWillingnessToPay = newVal ? "Y" : "N";
            } else {
                this.includeWillingnessToPay = this.savedCardWillingnessToPay;
            }
        },
        clientChart: function() {
            if (this.clientChart != null && this.clientChart.clientChartId > 0) {
                let params = new URLSearchParams(this.clientChart.criteria);
                this.isSavedCard = params.get("auto_process_recommendations_by_ai") === "true";

                if (this.isSavedCard) {
                    if (typeof this.clientSettings.aiTypeId != "undefined" && this.clientSettings.aiTypeId != null){
                         this.recommendations_ai_type_id = this.clientSettings.aiTypeId;
                    } else {
                         this.recommendations_ai_type_id = 0;
                    }
                    this.displayProfileRecommendations = true;
                    this.loadCriteriaData();
                } else {
                    this.processingComplete = false;    
                }
            } else {
                this.loadDefaultCriteria();
                this.isSavedCard = false;
                this.processingComplete = false;
            }
            this.deactivateGeneratedThemesButton = this.isInsiderUser && !this.isSavedCard ? true : false;
            this.oneTimeRunOnlyForInsiderUser = this.isInsiderUser && this.isSavedCard ? true : false;
        },
        entrySurveyCode: function(newVal, oldVal) {
            this.getClientSettings();
            this.isSavedCard = false;
            this.resetValues();
        },
        recommendationsData(newVal) {
            if (newVal && this.autoProcessRecommendationsByAI) {
                this.generateProfileRecommendations();
            }
        },
        clientSettings() {
            if (!this.isSavedCard) {
                if (typeof this.clientSettings.aiTypeId != "undefined" && this.clientSettings.aiTypeId != null){
                    this.recommendations_ai_type_id = this.clientSettings.aiTypeId;
                } else {
                    this.recommendations_ai_type_id = 0;
                }
            }
        }
    },
};
</script>
